import { render, staticRenderFns } from "./SmsFormTab.vue?vue&type=template&id=33609f76"
import script from "./SmsFormTab.vue?vue&type=script&lang=js"
export * from "./SmsFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports